import i18n from '@/i18n'
export default [
  // AI物料助手-对话模式
  {
    path: 'chatHome',
    component: () => import('@/views/modules/AI/chatHome/index'),
    name: 'chatHome',
    meta: { 
      title: 'AI会话',
      needToken: true,
      hideFooter: true // 隐藏页脚
    }
  },
  // AI物料助手-批任务模式
  {
    path: 'materialAssistantBatch',
    component: () => import('@/views/modules/AI/materialAssistant/batch'),
    name: 'materialAssistantBatch',
    meta: { 
      title: 'AI物料助手-批任务模式',
      needToken: true
    }
  },
  // AI物料助手-批任务模式-数据列表
  {
    path: 'materialAssistantList',
    component: () => import('@/views/modules/AI/materialAssistant/list'),
    name: 'materialAssistantList',
    meta: { 
      title: 'AI物料助手数据',
      needToken: true
    }
  },
]
